import React, { useEffect } from 'react';
import { push } from 'connected-react-router';

import { PUBLISHER_PAYMENT_SETTINGS } from 'redux/router';
import { selectActiveOrganization } from 'redux/auth';
import { logAndCaptureException } from 'utils';
import { getLocationParams } from 'lib/frontend/utils/browser';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import LoadingState from 'components/LoadingState';
import ToastActions from 'redux/toast';
import { exists } from 'lib/types';
import { apiPost } from 'api/typed';
import { ColumnService } from 'lib/services/directory';

export default function StripeConnect() {
  const activeOrganization = useAppSelector(selectActiveOrganization);
  const oauthCode = getLocationParams().get('code');
  const dispatch = useAppDispatch();

  useEffect(() => {
    const setOAuthCode = async () => {
      if (!exists(activeOrganization) || !oauthCode) return;

      try {
        const result = await apiPost<'payments/update-connected-account'>(
          'payments/update-connected-account',
          {
            code: oauthCode,
            organizationId: activeOrganization.id
          }
        );
        if (result.success) {
          dispatch(
            ToastActions.toastSuccess({
              headerText: 'Stripe account linked successfully',
              bodyText:
                'All payouts to this publication will be sent to the linked account.'
            })
          );
        } else {
          dispatch(
            ToastActions.toastError({
              headerText: 'Failed to link Stripe account',
              bodyText: `${result.error}. Please try again in a few minutes or contact support.`
            })
          );
          throw new Error(result.error);
        }
        dispatch(push(PUBLISHER_PAYMENT_SETTINGS));
      } catch (err) {
        logAndCaptureException(
          ColumnService.PAYMENTS,
          err,
          'Failed to link Stripe account',
          {
            activeOrganization: activeOrganization?.id
          }
        );
      }
    };
    void setOAuthCode();
  }, [oauthCode, activeOrganization?.id]);
  return <LoadingState />;
}
